import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Tooltip,
  TextInput,
  FormGroup,
  Select,
  Checkbox,
  Card,
} from "gumdrops";
import { ModalProvider } from "../../utils/modalContext";
import ModalExample from "../ModalExample";
import CreateAdForm from "../CreateAdForm";
import MoveToFolderForm from "../MoveToFolderForm";

const Campaign = () => {
  const [bulkMenu, setBulkMenu] = useState(false);
  const [create, setCreate] = useState(false);
  return (
    <div className="gds-layout__container">
      {/* <Link
        to="/"
        className="gds-button gds-button--outline gds-button--sm -m-b-3"
      >
        <i className="fas fa-arrow-left -m-r-1"></i> Back to Home
      </Link> */}
      <div className="gds-flex gds-flex--justify-between gds-flex--align-center -m-b-2">
        <div className="gds-flex gds-flex--align-end">
          <h1 className="gds-text--header-sm ">Boost OLV Q4 2020</h1>
          <Tooltip text="Jira Link" position="bottom">
            <Button size="sm" context="link" className="-m-l-3 -p-a-0">
              <i className="fas fa-sm fa-link" /> Jira
            </Button>
          </Tooltip>
          <Tooltip text="Edit Name and Link" position="bottom">
            <Button
              size="sm"
              context="link"
              className="-m-l-3 -p-a-0 -color-tx-lt-5 "
            >
              <i className="fas fa-sm fa-edit" />
            </Button>
          </Tooltip>
        </div>
        <ModalProvider>
          <div className="custom-menu-button ">
            <Button
              size="sm"
              context="primary"
              className="-m-l-2"
              onClick={() => setCreate(!create)}
            >
              Create <i class="fas fa-plus"></i>
            </Button>
            {create && (
              <Card
                style={{
                  position: "absolute",
                  top: 35,
                  right: 0,
                  zIndex: 100,
                  minWidth: 140,
                }}
              >
                <ModalExample
                  actionTitle="Create Ad"
                  size="xs"
                  context="link"
                  title="Create Ad"
                  content={<CreateAdForm />}
                />
                <Link
                  to="/hype"
                  className="gds-button gds-button--xs gds-button--link"
                >
                  Hype Upload
                </Link>
              </Card>
            )}
          </div>
        </ModalProvider>
      </div>
      <div className="gds-flex -m-b-2">
        <div className="gds-flex__item">
          <FormGroup>
            <TextInput
              className=""
              name="name"
              onChange={() => console.log("text input")}
              placeholder="Search"
              size="sm"
              type="text"
            />
          </FormGroup>
        </div>
        <div className="gds-flex__item gds-flex__item--grow-0">
          <Button size="sm" context="outline" className="-m-l-2">
            Filter
            <i className="fas  fa-filter -m-l-2" />
          </Button>
        </div>
      </div>

      <div className="gds-flex__item gds-button-group gds-button-group--xs -inline-block -m-r-2">
        <button
          className="gds-button-group__button gds-button--outline gds-button--xs -pointer-events--none"
          style={{ width: "50px", height: 29 }}
          type="button"
        >
          <div className="gds-form-group">
            <div className="gds-form-group__checkbox gds-form-group__checkbox--sm">
              <label
                className="gds-form-group__checkbox-label -m-l-2"
                style={{ top: 1 }}
              >
                <input
                  type="checkbox"
                  className="gds-form-group__checkbox-input -pointer-events--auto"
                  name="In-Screen"
                  defaultValue="on"
                />
                <span className="gds-form-group__checkbox-indicator" />
              </label>
            </div>
          </div>
        </button>
        <button
          className="gds-button-group__button gds-button--outline gds-button--xs  -pointer-events--none"
          style={{ minWidth: "80px" }}
          type="button"
        >
          1 selected
        </button>
        <div
          className={`gds-button-dropdown gds-button-dropdown--sm gds-button-dropdown--in-group ${
            bulkMenu ? "gds-button-dropdown--active" : ""
          }`}
        >
          <button
            onClick={() => setBulkMenu(!bulkMenu)}
            className="gds-button-dropdown__button gds-button--primary gds-button--xs"
            type="button"
            style={{ width: "100px" }}
          >
            Action
          </button>
          <ul
            className="gds-button-dropdown__menu -color-bg-white"
            style={{ width: "200px" }}
          >
            <li className="gds-button-dropdown__menu-item gds-text--body-xs">
              <div
                className="gds-button-dropdown__menu-link -color-tx-dk-5"
                onClick={() => {
                  setBulkMenu(!bulkMenu);
                  alert("Approved");
                }}
                style={{ fontSize: ".7rem" }}
              >
                Copy Links to Clipboard
              </div>
            </li>

            <ModalProvider>
              <ModalExample
                actionTitle="Move to Folder"
                size="xs"
                context="link"
                title="Move to Folder"
                content={<MoveToFolderForm />}
              />
            </ModalProvider>
          </ul>
        </div>
      </div>

      <div className="gds-container -color-bg-white -p-a-0 -color-bd-lt-2">
        <div className="gds-table--responsive gds-table--striped">
          <table className="gds-table gds-table--sm">
            <thead>
              <tr className="gds-table__row">
                <th
                  className="gds-table__header gds-table__header--white -text-left"
                  style={{ width: 50 }}
                ></th>
                <th
                  className="gds-table__header gds-table__header--white -text-left"
                  style={{ width: 200 }}
                >
                  Preview
                </th>
                <th className="gds-table__header gds-table__header--white -text-left">
                  Name
                </th>
                <th className="gds-table__header gds-table__header--white -text-left">
                  Type
                </th>
                <th
                  className="gds-table__header gds-table__header--white"
                  style={{ width: 90 }}
                >
                  Hype
                </th>
                <th
                  className="gds-table__header gds-table__header--white -text-left"
                  style={{ width: 120 }}
                >
                  Size
                </th>

                <th
                  className="gds-table__header gds-table__header--white -text-left"
                  style={{ width: 120 }}
                >
                  Updated
                </th>

                <th
                  className="gds-table__header gds-table__header--white"
                  style={{ width: 170 }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="gds-table__row">
                <td>
                  <Checkbox size="sm" className="-m-l-2" />
                </td>
                <td
                  style={{
                    backgroundImage:
                      "url(https://c.gumgum.com/adbuilder/21574/1/PNHvXB7.png)",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    height: 60,
                  }}
                ></td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    Boost OLV Q4 2020
                  </Link>
                </td>

                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    In-Screen Animated
                  </Link>
                </td>
                <td className="-text-center">
                  <i className="fas fa-sm fa-check" />
                </td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    0kb / 450kb
                  </Link>
                </td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    11/27/2020
                  </Link>
                </td>

                <td>
                  <div className="gds-flex gds-flex--justify-center">
                    <Tooltip text="Demo Link" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-link" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Mobile Demo Link" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-mobile-alt" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Download" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-download" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Copy Markup to Clipboard" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-clipboard" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Edit Name" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-edit"></i>
                      </button>
                    </Tooltip>
                    <Tooltip text="Clone" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-clone" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Delete Unit" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-trash" />
                      </button>
                    </Tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr className="-color-bd-lt-2 -m-a-0" />
          <div className="gds-flex gds-flex--align-center -p-a-2">
            <div className="gds-flex__item gds-flex__item--grow-1 gds-text--body-xs">
              317 results
            </div>
            <div className="gds-flex__item gds-flex__item--grow-2">
              <nav className="">
                <ul
                  className="gds-pagination gds-pagination--xs"
                  data-paganimate=""
                >
                  <li className="gds-pagination__page-item">
                    {" "}
                    <a
                      href="/"
                      className="gds-pagination__page-link"
                      aria-label="Previous"
                      data-page-change="prev"
                    >
                      {" "}
                      <span className="-vis-hidden" aria-hidden="true">
                        «
                      </span>{" "}
                      <span className="-sr-only">Previous</span>{" "}
                    </a>{" "}
                  </li>
                  <li
                    className="gds-pagination__page-item gds-pagination__page-item--active"
                    data-paginate-active="true"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      1
                    </a>
                  </li>
                  <li
                    className="gds-pagination__page-item"
                    data-paginate-active="false"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      2
                    </a>
                  </li>
                  <li
                    className="gds-pagination__page-item"
                    data-paginate-active="false"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      3
                    </a>
                  </li>
                  <li
                    className="gds-pagination__page-item"
                    data-paginate-active="false"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      4
                    </a>
                  </li>
                  <li
                    className="gds-pagination__page-item"
                    data-paginate-active="false"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      5
                    </a>
                  </li>
                  <li className="gds-pagination__page-item">
                    <a
                      href="/"
                      className="gds-pagination__page-link"
                      aria-label="Next"
                      data-page-change="next"
                    >
                      <span className="-vis-hidden" aria-hidden="true">
                        »
                      </span>{" "}
                      <span className="-sr-only">Next</span>
                    </a>
                  </li>
                  <span className="gds-pagination__page-indicator" />
                </ul>
              </nav>
            </div>
            <div className="gds-flex__item gds-flex__item--grow-1 gds-flex gds-flex--justify-end">
              <Select
                options={[
                  {
                    name: "20",
                    value: "1",
                  },
                  {
                    name: "50",
                    value: "2",
                  },
                  {
                    name: "100",
                    value: "3",
                  },
                ]}
                size="xs"
                name="numItems"
                defaultValue="1"
                className=""
                style={{ maxWidth: "70px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Campaign;
